module.exports = __webpack_public_path__ + "img/activity_bg.db9c8770.png";